function Footer() {
  return (
    <footer>
      <h3>
        Created by <a href="https://github.com/skininja673">Akalpit</a>,&nbsp;
        <a href="https://github.com/maxtclaw">Max</a>,&nbsp;
        <a href="https://github.com/shanningtatum">Shannon</a>, and&nbsp;
        <a href="https://github.com/wendiz16">Wendi</a> @ Juno College
      </h3>
      <h3>
        Powered by&nbsp;
        <a href="https://developer.mapquest.com/">MapQuest API</a>
      </h3>
    </footer>
  );
}

export default Footer;
